import React from "react";
import {
  FaSchool,
  FaChild,
  FaChalkboardTeacher,
  FaCheckCircle,
} from "react-icons/fa";
const highlights = [
  "Learning while playing",
  "Education with ethics",
  "Traditional values",
  "Self-help development",
  "Discipline & time management",
  "Friendly teachers & staff",
];
const AboutSchool = () => {
  return (
    <section className="relative py-16 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-white to-red-50 overflow-hidden">
      <div className="absolute top-0 left-0 w-64 h-64 bg-orange-300/20 rounded-full blur-3xl -translate-x-20"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-red-300/20 rounded-full blur-3xl translate-x-20"></div>

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-5 py-2 text-sm font-semibold text-red-600 bg-red-100 rounded-full mb-4">
            Aboutschool
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900">
            About{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Us
            </span>
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          {/* Left Card */}
          <div className="bg-gradient-to-br from-red-600 to-orange-500 rounded-[32px] p-7 md:p-9 text-white shadow-2xl flex flex-col justify-between">
            <div>
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6">
                <FaSchool className="text-3xl" />
              </div>

              <h3 className="text-3xl md:text-4xl font-extrabold leading-tight mb-5">
                Education With Values & Modern Learning
              </h3>
              <p className="text-white/90 text-sm md:text-base leading-8 mb-6">
                The concept of the School is based on the philosophy of renowned
                Academician and Scientist Prof. J. P. Lal, who felt the need of
                an institution that provides children a proper and balanced dose
                of education and ethics along with modern amenities of learning.
              </p>
              <p className="text-white/90 text-sm md:text-base leading-8">
                Our principle is <strong>“learning while playing”</strong>,
                because talent and passion count in success. We nourish children
                in a healthy manner without hurting their childhood.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-8">
              {highlights.map((item, index) => (
                <div
                  key={index}
                  className="bg-white/15 border border-white/20 rounded-2xl p-3 text-sm font-semibold"
                >
                  <FaCheckCircle className="inline mr-2 text-yellow-200" />
                  {item}
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white rounded-[32px] shadow-2xl border border-orange-100 p-7 md:p-9">
            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="w-12 h-12 rounded-2xl bg-red-100 text-red-600 flex items-center justify-center shrink-0">
                  <FaChild className="text-xl" />
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">
                    Play Group Learning
                  </h4>
                  <p className="text-gray-600 text-sm md:text-[15px] leading-8 text-justify">
                    At Play Group stage, children are exposed to basic learning
                    activities that help them become independent faster. These
                    activities develop self-help qualities like eating food
                    themselves, dressing up, maintaining cleanliness, exchanging
                    greetings, sharing food and toys, and identifying their
                    possessions.
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-12 h-12 rounded-2xl bg-orange-100 text-orange-600 flex items-center justify-center shrink-0">
                  <FaSchool className="text-xl" />
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">
                    Junior School Growth
                  </h4>
                  <p className="text-gray-600 text-sm md:text-[15px] leading-8 text-justify">
                    At middle or junior school, students learn discipline and
                    time management to complete their work timely and
                    efficiently. Their energy is guided in a constructive way
                    through meaningful academic and co-curricular learning.
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-12 h-12 rounded-2xl bg-red-100 text-red-600 flex items-center justify-center shrink-0">
                  <FaChalkboardTeacher className="text-xl" />
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">
                    Teachers & Staff
                  </h4>
                  <p className="text-gray-600 text-sm md:text-[15px] leading-8 text-justify">
                    The teachers and staff are caring, friendly and well versed
                    in their profiles. Their purpose is to stimulate every
                    child’s enthusiasm for learning and guide them without
                    interfering with their natural desire to become independent.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-7 bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-5 border border-orange-100">
              <p className="text-gray-700 text-sm md:text-base leading-7 font-medium">
                All this leads to children realizing their full potential
                through learning that is meaningful, experiential and fun.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default AboutSchool;